import type { CanvasView, ShotView, StoryboardView } from "@dramapie/shared";
import { useState } from "react";

import { DATA_TABS, projectionFor, type DataTabId } from "../../lib/projections";
import { JsonView } from "../workspace/JsonView";

export interface DataViewProps {
  view: StoryboardView | null;
  canvas: CanvasView | null;
  activeShot: ShotView | null;
}

/**
 * 数据（左栏「内容导航」→ 主区视图）。
 *
 * 三份投影就放在这里，不再塞进右栏：领域数据是唯一真源，故事板与画布
 * 都是同一份数据的投影——和「故事板 / 画布 / 时间线」是同一份数据的三种看法
 * 是同一个信息架构。
 */
export function DataView({ view, canvas, activeShot }: DataViewProps) {
  const [tab, setTab] = useState<DataTabId>("domain");
  const active = DATA_TABS.find((item) => item.id === tab) ?? DATA_TABS[0];
  const payload = projectionFor(tab, { shot: activeShot, view, canvas });

  return (
    <section className="dp-data-view" aria-label="数据">
      <header className="dp-data-head">
        <div>
          <p className="dp-label">data · 唯一真源与两份投影</p>
          <h2 className="dp-data-title">数据</h2>
          <p className="dp-data-meta">
            领域数据是唯一真源；故事板与画布都是同一份数据的投影，不另存一份。
          </p>
        </div>
      </header>

      <div className="dp-data-pane">
        <div className="dp-data-tabs" role="tablist" aria-label="数据投影">
          {DATA_TABS.map((item) => (
            <button
              key={item.id}
              type="button"
              role="tab"
              aria-selected={tab === item.id}
              onClick={() => setTab(item.id)}
            >
              {item.label}
            </button>
          ))}
        </div>

        <p className="dp-data-note">{active ? active.note : ""}</p>

        {payload ? (
          <JsonView data={payload} className="dp-data-json" />
        ) : (
          <p className="dp-pane-empty">
            {tab === "canvas"
              ? "画布投影还没加载出来（当前集可能没有画布数据，或请求失败）。"
              : "故事板还没加载，暂时没有可投影的数据。"}
          </p>
        )}
      </div>
    </section>
  );
}
